import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import Contactpage from '../../components/Contactpage/Contactpage'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import { useLanguage } from '../../i18n/LanguageContext';

const ContactPage =() => {
    const { t } = useLanguage();

    return(
        <Fragment>
            <Navbar/>
            <PageTitle pageTitle={t('contact.pageTitle')} pagesub={t('contact.pageSubTitle')}/>
            <Contactpage/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default ContactPage;
